module.exports = __webpack_public_path__ + "img/favicon.fce5414c.png";